import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form as FormikForm } from "formik";
import { Link, useLocation } from "react-router-dom";
import {
  getZones,
  getCities,
  postProperty,
  propertyTypes,
  facilitiesTypes,
} from "../../../utility/apiServices/propertiesServices";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ProgressSteps from "./progressComponent";
import { useGoogleMapsLoader } from "../../../utility/googleApiLoader";
import { useTranslation } from "react-i18next";

// Components
import Step0PropertyType from "./components/Step0PropertyType";
import Step1Address from "./components/Step1Address";
import Step2Description from "./components/Step2Description";
import Step3PricingAndRooms from "./components/Step3PricingAndRooms";
import Step4Facilities from "./components/Step4Facilities";
import Step5Images from "./components/Step5Images";

// Utils
import { getValidationSchemas } from "./utils/validationSchemas";
import { getInitialValues } from "./utils/initialValues";

const AddPropertyForm = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const propertyData = location?.state?.propertyData;
  const { t } = useTranslation();
  const language = localStorage.getItem("language");

  const [step, setStep] = useState(0);
  const [roomTypee, setroomTypee] = useState(
    propertyData?.room_type || "single"
  );
  const [initialPropertyValue, setInitialPropertyValue] = useState(propertyData);
  const [zones, setZones] = useState([]);
  const [selectedzones, setselectedzone] = useState(propertyData?.zone_id);
  const [cities, setcities] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [currentRoomIndex, setCurrentRoomIndex] = useState(0);
  const [submitted, setsubmitted] = useState(false);
  const [apicalled, setapicalled] = useState(false);
  const [SelectedImagesError, setSelectedImagesError] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const { isLoaded, loadError } = useGoogleMapsLoader();

  const [roomImages, setRoomImages] = useState([
    { imagePreviews: [], selectedImages: [] },
  ]);

  const [state, setState] = useState({
    stateTypes: [],
    facilitiesTypes: [],
    selectedFacilitiesTypes: [],
  });

  const [roomErrors, setRoomErrors] = useState({});
  const [selectedRoom, setSelectedRoom] = useState(null);

  // Debug logging for property data
  useEffect(() => {
    console.log("AddPropertyForm - propertyData received:", propertyData);
    if (propertyData) {
      setInitialPropertyValue(propertyData);
      // Also update selected facilities if editing
      if (propertyData.facilities && Array.isArray(propertyData.facilities)) {
        handleState("selectedFacilitiesTypes", propertyData.facilities);
      }
      // Update zone and trigger city fetch if zone exists
      if (propertyData.zone_id) {
        setselectedzone(propertyData.zone_id);
      }
      // Update room type
      if (propertyData.room_type) {
        setroomTypee(propertyData.room_type);
      }
    }
  }, [propertyData]);

  useEffect(() => {
    if (propertyData?.images?.length > 0) {
      const newData = propertyData.images.flatMap((roomData) => {
        return Object.values(roomData).flatMap((images) => {
          // Check if images is an array before mapping
          if (Array.isArray(images) && images.length > 0) {
            return images.map((image) => {
              // Extract location string from image object
              return typeof image === 'object' && image.location ? image.location : image;
            });
          }
          return []; // Return empty array if not valid
        });
      });

      // Filter out any undefined or null values
      const filteredData = newData.filter((item) => item != null);
      setImagePreviews(filteredData);
    }
  }, [propertyData]);

  const handleState = (key, value) => {
    setState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleRoomClick = (roomIndex) => {
    setSelectedRoom(roomIndex);
  };

  useEffect(() => {
    //working  while  edit only -
    if (initialPropertyValue && initialPropertyValue.id) {
      if (selectedRoom || selectedRoom == 0) {
        const roomKey = `room${selectedRoom + 1}`;
        const roomImagesData =
          initialPropertyValue?.images?.[0]?.[roomKey]?.map((image) => image) ||
          [];
        const updatedRoomImages = [...roomImages];
        updatedRoomImages[selectedRoom] = {
          imagePreviews: roomImagesData,
          selectedImages: [],
        };
        setRoomImages(updatedRoomImages);
      }
    }
  }, [selectedRoom]);

  useEffect(() => {
    if (initialPropertyValue && initialPropertyValue.id) {
      {
        initialPropertyValue &&
          initialPropertyValue?.rooms.length > 0 &&
          initialPropertyValue?.rooms.map((val, index) => {
            const roomKey = `room${index + 1}`;
            const roomImagesData =
              initialPropertyValue?.images?.[0]?.[roomKey]?.map(
                (image) => image
              ) || [];
            const updatedRoomImages = [...roomImages];
            updatedRoomImages[selectedRoom] = {
              imagePreviews: roomImagesData,
              selectedImages: [],
            };
            setRoomImages(updatedRoomImages);
          });
      }
    }
  }, [step > 5]);

  const getPropertyTypes = async () => {
    try {
      const result = await propertyTypes();
      handleState("stateTypes", result);
    } catch (error) {
      console.log(error, "Check the error while getting types");
    }
  };

  const getFacilitiesTypes = async () => {
    try {
      const result = await facilitiesTypes();
      handleState("facilitiesTypes", result.data);
    } catch (error) {
      console.log(error, "Check the error while getting types");
    }
  };

  useEffect(() => {
    getFacilitiesTypes();
    getPropertyTypes();
  }, []);

  const handleRoomImageChange = (e, setFieldValue, roomIndex) => {
    const files = Array.from(e.target.files);
    console.log(
      `handleRoomImageChange - Room ${roomIndex}: ${files.length} files selected`
    );

    if (files.length === 0) {
      console.log("No files selected");
      return;
    }

    const filePreviews = files.map((file) => URL.createObjectURL(file));

    const updatedRoomImages = [...roomImages];

    if (!updatedRoomImages[roomIndex]) {
      updatedRoomImages[roomIndex] = { imagePreviews: [], selectedImages: [] };
    }

    updatedRoomImages[roomIndex].imagePreviews = [
      ...updatedRoomImages[roomIndex].imagePreviews,
      ...filePreviews,
    ];
    updatedRoomImages[roomIndex].selectedImages = [
      ...updatedRoomImages[roomIndex].selectedImages,
      ...files,
    ];

    // Update roomImages state
    setRoomImages(updatedRoomImages);
    console.log(
      `Room ${roomIndex} now has ${updatedRoomImages[roomIndex].selectedImages.length} images`
    );

    // Update the form field
    setFieldValue(
      `rooms[${roomIndex}].images`,
      updatedRoomImages[roomIndex].selectedImages
    );

    // Synchronize with initialPropertyValue
    const updatedInitialPropertyValue = { ...initialPropertyValue };
    const roomKey = `room${roomIndex + 1}`;

    // Ensure images array exists and is properly structured
    if (!updatedInitialPropertyValue.images) {
      updatedInitialPropertyValue.images = [{}];
    } else if (!Array.isArray(updatedInitialPropertyValue.images)) {
      updatedInitialPropertyValue.images = [{}];
    } else if (typeof updatedInitialPropertyValue.images[0] !== 'object' || Array.isArray(updatedInitialPropertyValue.images[0])) {
      updatedInitialPropertyValue.images[0] = {};
    }

    const currentRoomImages =
      updatedInitialPropertyValue.images[0]?.[roomKey] || [];
    updatedInitialPropertyValue.images[0][roomKey] = [
      ...currentRoomImages,
      ...files.map((file) => ({ location: URL.createObjectURL(file) })),
    ];
    setInitialPropertyValue(updatedInitialPropertyValue);

    setRoomImages(updatedRoomImages);
    setFieldValue(
      `rooms[${roomIndex}].images`,
      updatedRoomImages[roomIndex].selectedImages
    );
  };

  const handleRemoveRoomImage = (roomIndex, imageIndex, setFieldValue) => {
    const updatedRoomImages = [...roomImages];
    updatedRoomImages[roomIndex].imagePreviews = updatedRoomImages[roomIndex].imagePreviews.filter((_, i) => i !== imageIndex);
    updatedRoomImages[roomIndex].selectedImages = updatedRoomImages[roomIndex].selectedImages.filter((_, i) => i !== imageIndex);

    const updatedInitialPropertyValue = { ...initialPropertyValue };
    const roomKey = `room${roomIndex + 1}`;

    // Ensure images array exists and is properly structured
    if (updatedInitialPropertyValue?.images && Array.isArray(updatedInitialPropertyValue.images) &&
        typeof updatedInitialPropertyValue.images[0] === 'object' && !Array.isArray(updatedInitialPropertyValue.images[0])) {
      updatedInitialPropertyValue.images[0][roomKey] = updatedInitialPropertyValue.images[0][roomKey]?.filter((_, i) => i !== imageIndex);
    }
    setRoomImages(updatedRoomImages);
    setFieldValue(`rooms[${roomIndex}].images`, updatedRoomImages[roomIndex].selectedImages);
    setInitialPropertyValue(updatedInitialPropertyValue);
  };

  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = (setFieldValue) => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const addressComponents = place.address_components;
      const geometry = place.geometry;
      setFieldValue("street_address", place.formatted_address);
      setFieldValue("latitude", geometry.location.lat());
      setFieldValue("longitude", geometry.location.lng());

      const state = addressComponents.find((component) =>
        component.types.includes("administrative_area_level_1")
      )?.long_name;
      const area = addressComponents.find((component) =>
        component.types.includes("sublocality_level_1")
      )?.long_name;
      const postalCode = addressComponents.find((component) =>
        component.types.includes("postal_code")
      )?.long_name;
      const country = addressComponents.find((component) =>
        component.types.includes("country")
      )?.long_name;

      if (state) setFieldValue("state", state);
      if (area) setFieldValue("area", area);
      if (postalCode) setFieldValue("post_code", postalCode);
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  const fetchZone = async () => {
    const zones = await getZones();
    if (zones?.length) {
      setZones(zones);
    }
  };

  const fetchcities = async () => {
    let cities = await getCities({ zone_id: selectedzones });
    if (cities?.length) {
      setcities(cities);
    }
  };

  useEffect(() => {
    fetchZone();
  }, []);

  useEffect(() => {
    if (selectedzones) fetchcities();
  }, [selectedzones]);

  useEffect(() => {
    console.log("selectedImages :", selectedImages);
  }, [selectedImages]);

  const handleAddRoom = (push) => {
    const newRoomIndex = currentRoomIndex + 1;
    setRoomErrors((prevErrors) => ({
      ...prevErrors,
      [`room${newRoomIndex}`]: false,
    }));

    push({
      numberOfBeds: "",
      size: "",
      adults: 0,
      children: 0,
      pets: 0,
    });
    setCurrentRoomIndex(currentRoomIndex + 1);
  };

  const handleRemoveRoom = (remove, index) => {
    setRoomErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[`room${index + 1}`];
      return updatedErrors;
    });
    if (currentRoomIndex === index) {
      setCurrentRoomIndex(currentRoomIndex - 1);
    } else if (currentRoomIndex > index) {
      setCurrentRoomIndex(currentRoomIndex - 1);
    }
    remove(index);
  };

  const handlePrevious = () => {
    if (step > 0) {
      setStep((prevStep) => prevStep - 1);
    }
  };

  const checkForErrors = (values, roomImages, imagePreviews) => {
    const updatedErrors = {};
    let hasError = false;

    const roomsArray = Array.isArray(values.rooms)
      ? values.rooms
      : JSON.parse(values.rooms);

    roomsArray.forEach((room, roomIndex) => {
      if (roomImages[roomIndex]) {
        if (
          roomImages[roomIndex].imagePreviews.length === 0 &&
          roomImages[roomIndex].selectedImages.length === 0
        ) {
          updatedErrors[`room${roomIndex + 1}`] = t(
            "AddProperties.roomImageRequired",
            { roomNumber: roomIndex + 1 }
          );
          hasError = true;
        } else {
          updatedErrors[`room${roomIndex + 1}`] = "";
        }
      } else {
        updatedErrors[`room${roomIndex + 1}`] = t(
          "AddProperties.roomImageRequired",
          { roomNumber: roomIndex + 1 }
        );
        hasError = true;
      }
    });

    setRoomErrors(updatedErrors);
    return hasError;
  };

  function funFilterDataForMultipleImages(data) {
    return data
      .map((room) => {
        // Skip if room is not an object or is an array
        if (typeof room !== 'object' || Array.isArray(room) || room === null) {
          return {};
        }

        const filteredRoom = {};
        for (let key in room) {
          // Ensure room[key] is an array before filtering
          if (!Array.isArray(room[key])) {
            continue;
          }

          const filteredItems = room[key].filter(
            (item) =>
              item &&
              item.location &&
              !item.location.includes("localhost") &&
              !item.location.includes("blob")
          );
          if (filteredItems.length > 0) {
            filteredRoom[key] = filteredItems;
          }
        }
        return filteredRoom;
      })
      .filter((room) => Object.keys(room).length > 0);
  }

  const handleSubmit = async (values) => {
    if (step < 5) {
      setStep((prev) => prev + 1);
      setsubmitted(false);
    } else {
      if (values.room_type === "multi") {
        const hasError = checkForErrors(values, roomImages, imagePreviews);
        if (hasError) {
          console.log("Errors exist, cannot submit");
          return;
        }
      } else {
        const hasError = values?.rooms &&
          (Array.isArray(values.rooms) ? values.rooms : JSON.parse(values.rooms)).some((room, roomIndex) => {
            if (roomImages[roomIndex]) {
              if (
                imagePreviews.length === 0 &&
                roomImages[roomIndex].selectedImages.length === 0
              ) {
                setSelectedImagesError(true);
                return true;
              }
            } else {
              setSelectedImagesError(true);
              return true;
            }
            setSelectedImagesError(false);
            return false;
          });

        if (hasError) {
          return;
        }
      }

      setSelectedImagesError(false);
      setsubmitted(false);
      setSelectedImagesError(false);
      setapicalled(true);

      const formData = new FormData();
      if (initialPropertyValue?.id) {
        formData.append("id", initialPropertyValue?.id);
        if (values.room_type === "multi") {
          console.log(
            initialPropertyValue.images,
            "check Property images =-=-="
          );
          if (
            initialPropertyValue.images &&
            initialPropertyValue.images.length > 0
          ) {
            const filteredImages = funFilterDataForMultipleImages(
              initialPropertyValue.images
            );
            formData.append("prevImage", JSON.stringify(filteredImages) || []);
          }
        } else {
          if (imagePreviews && imagePreviews.length > 0) {
            const filteredPreviews = imagePreviews.filter((preview) => {
              // Handle both string URLs and image objects
              const url = typeof preview === 'object' && preview.location ? preview.location : preview;
              return url && typeof url === 'string' && !url.includes("localhost");
            }).map((preview) => {
              // Ensure we're working with strings
              return typeof preview === 'object' && preview.location ? preview.location : preview;
            });
            if (filteredPreviews.length > 0) {
              formData.append("prevImage", JSON.stringify(filteredPreviews));
            }
          }
        }
      }

      formData.append("property_type_id", values.property_type_id);
      formData.append("street_address", values.street_address);
      formData.append("country", values.country);
      formData.append("flat_suite", values.flat_suite);
      formData.append("city_id", values.city_id);
      formData.append("state", values.state);
      formData.append("zone_id", values.zone_id);
      formData.append("post_code", values.post_code);
      formData.append("area", values.area);
      formData.append("phone_number", values.phone_number);
      formData.append("short_description", values.short_description);
      formData.append("long_description", values.long_description);
      formData.append("latitude", values?.latitude);
      formData.append("longitude", values?.longitude);
      formData.append("short_description_hebrew", values.short_description_hebrew);
      formData.append("long_description_hebrew", values.long_description_hebrew);
      formData.append("is_available_for_booking", values.is_available_for_booking);
      formData.append("price_for_weekends", values.price_for_weekends);
      formData.append("weekend_discounted_price", values.weekend_discounted_price);
      formData.append("price_for_weekdays", values.price_for_weekdays);
      formData.append("weekdays_discounted_price", values.weekdays_discounted_price);

      if (values.room_type === "multi") {
        roomImages.forEach((room, roomIndex) => {
          room.selectedImages.forEach((image) => {
            formData.append(`images[${roomIndex}]`, image);
          });
        });
      } else {
        selectedImages.forEach((image) => {
          formData.append("images", image);
        });
      }

      formData.append("rooms", JSON.stringify(values.rooms));
      formData.append("room_type", values.room_type);
      formData.append("facilities", JSON.stringify(values.facilities));
      formData.append("status", true);
      formData.append("is_active", true);

      const addproperty = await postProperty(formData);

      if (addproperty.status) {
        navigate("/my-properties");
      } else {
        Swal.fire({
          icon: "error",
          text:
            addproperty.message || t("AddProperties.somethingWentWrong"),
        });
        setsubmitted(false);
        setapicalled(false);
      }
    }
  };

  const toggleFacility = (engname, herbewname, image_url, setFieldValue) => {
    const preResult = state.selectedFacilitiesTypes || [];
    const saveValue = {
      imageUrl: image_url,
      engname: engname,
      herbewname: herbewname,
    };
    const isAlreadySelected = preResult.some(
      (item) => item.engname === engname
    );
    if (isAlreadySelected) {
      const newRes = preResult.filter((item) => item.engname !== engname);
      handleState("selectedFacilitiesTypes", newRes);
      setFieldValue("facilities", newRes);
    } else {
      handleState("selectedFacilitiesTypes", [...preResult, saveValue]);
      setFieldValue("facilities", [...preResult, saveValue]);
    }
  };

  const handleImageChange = (e, setFieldValue) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      return;
    }

    const filePreviews = files.map((file) => URL.createObjectURL(file));

    // Filter out non-File objects from selectedImages (in case of edit mode)
    const existingFiles = selectedImages.filter(img => img instanceof File);
    const newSelectedImages = [...existingFiles, ...files];

    setImagePreviews([...imagePreviews, ...filePreviews]);
    setSelectedImages(newSelectedImages);
    setFieldValue("images", newSelectedImages);
    setSelectedImagesError(false);
  };

  const steps_data = [
    {
      header: t("AddProperties.PropertyType"),
      description: t("AddProperties.TypeDes"),
    },
    {
      header: t("AddProperties.propertyAddress"),
      description: t("AddProperties.addressType"),
    },
    {
      header: t("AddProperties.addressType"),
      description: t("AddProperties.describeDes"),
    },

    {
      header: t("AddProperties.accomodationDetails"),
      description: t("AddProperties.accomodationDetailsDes"),
    },
    {
      header: t("AddProperties.selectAminities"),
      description: t("AddProperties.selectAminitiesDes"),
    },
    {
      header: t("AddProperties.AddImages"),
      description: t("AddProperties.AddImagesDes"),
    },
  ];

  const validationSchemas = getValidationSchemas(t);
  const initialValues = getInitialValues(initialPropertyValue);

  return (
    <React.Fragment>
      <section className="commonpad1">
        <Container>
          <Row>
            <Col>
              <div className="stepsBox">
                <div className="stepsHeader">
                  <h2>{steps_data[step].header}</h2>
                  <p>{steps_data[step].description}</p>
                </div>
                <div className="stepsBox__Shadow">
                  <ProgressSteps step={step} />
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchemas[step]}
                    onSubmit={(values) => {
                      setsubmitted(true);
                      handleSubmit(values);
                    }}
                    validateOnChange
                    validateOnBlur
                    enableReinitialize
                  >
                    {({ values, isSubmitting, setFieldValue, errors }) => (
                      <FormikForm>
                        {step === 0 && (
                          <Step0PropertyType
                            values={values}
                            setFieldValue={setFieldValue}
                            state={state}
                            submitted={submitted}
                            errors={errors}
                          />
                        )}
                        {step === 1 && (
                          <Step1Address
                            values={values}
                            setFieldValue={setFieldValue}
                            submitted={submitted}
                            errors={errors}
                            t={t}
                            isLoaded={isLoaded}
                            onLoad={onLoad}
                            onPlaceChanged={onPlaceChanged}
                            zones={zones}
                            cities={cities}
                            setselectedzone={setselectedzone}
                          />
                        )}
                        {step === 2 && (
                          <Step2Description
                            values={values}
                            setFieldValue={setFieldValue}
                            submitted={submitted}
                            errors={errors}
                            t={t}
                            language={language}
                          />
                        )}
                        {step === 3 && (
                          <Step3PricingAndRooms
                            values={values}
                            setFieldValue={setFieldValue}
                            submitted={submitted}
                            errors={errors}
                            t={t}
                            roomTypee={roomTypee}
                            setroomTypee={setroomTypee}
                            setCurrentRoomIndex={setCurrentRoomIndex}
                            currentRoomIndex={currentRoomIndex}
                            handleAddRoom={handleAddRoom}
                            handleRemoveRoom={handleRemoveRoom}
                          />
                        )}
                        {step === 4 && (
                          <Step4Facilities
                            values={values}
                            setFieldValue={setFieldValue}
                            submitted={submitted}
                            errors={errors}
                            state={state}
                            toggleFacility={toggleFacility}
                          />
                        )}
                        {step === 5 && (
                          <Step5Images
                            values={values}
                            setFieldValue={setFieldValue}
                            submitted={submitted}
                            roomImages={roomImages}
                            selectedRoom={selectedRoom}
                            handleRoomClick={handleRoomClick}
                            handleRoomImageChange={handleRoomImageChange}
                            handleRemoveRoomImage={handleRemoveRoomImage}
                            imagePreviews={imagePreviews}
                            handleImageChange={handleImageChange}
                            apicalled={apicalled}
                            SelectedImagesError={SelectedImagesError}
                            selectedImages={selectedImages}
                            setSelectedImages={setSelectedImages}
                            setImagePreviews={setImagePreviews}
                            roomErrors={roomErrors}
                            t={t}
                          />
                        )}

                        <div className="roomFlex">
                          <div>
                            <Button
                              variant="secondary"
                              onClick={handlePrevious}
                              disabled={step === 0 || apicalled}
                            >
                              {t("AddProperties.previous")}
                            </Button>
                          </div>
                          <div>
                            <Button
                              variant="primary"
                              disabled={apicalled}
                              type="submit"
                              onClick={() => setsubmitted(true)}
                            >
                              {apicalled ? (
                                <span className="spinner"></span>
                              ) : step < 5 ? (
                                t("AddProperties.next")
                              ) : (
                                t("AddProperties.submit")
                              )}
                            </Button>
                          </div>
                        </div>
                      </FormikForm>
                    )}
                  </Formik>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AddPropertyForm;
